var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "div",
          { staticClass: "agents-reg-img", staticStyle: { padding: "16px" } },
          [
            _c(
              "el-row",
              { staticClass: "backdrop", staticStyle: { padding: "22px" } },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("img", {
                      attrs: {
                        loading: "lazy",
                        src: require("../../assets/are-you-real-estate-agent.svg")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      "margin-top": "22px"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "agent-title" }, [
                      _vm._v("Do you want to list on UNIFI Property?")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "agent-paragraph" }, [
                      _vm._v(
                        "Register to start listing your properties on UNIFI Property"
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "agent-registration-btn",
                        attrs: { type: "primary" }
                      },
                      [_vm._v("Register")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                staticClass: "backdrop",
                staticStyle: { padding: "22px", "margin-top": "40px" }
              },
              [
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("img", {
                      attrs: {
                        loading: "lazy",
                        src: require("../../assets/are-you-in-the-finance-industry.svg")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center",
                      "margin-top": "31px"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "agent-title" }, [
                      _vm._v("Introducing property to your clients?")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c("span", { staticClass: "agent-paragraph" }, [
                      _vm._v(
                        "Real Estate Agents, Buyers Agents, Mortgage Brokers, Accountants,\n            Advisers and Migration Agents"
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "center"
                    },
                    attrs: { span: 24 }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "agent-registration-btn",
                        attrs: { type: "primary" }
                      },
                      [_vm._v("Register")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15dd6f40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15dd6f40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/agentsRegistration.vue
// module id = null
// module chunks = 